import React, { Component } from "react";
import { connect } from 'react-redux'
import MakeOrderDatePriceInfo from "./MakeOrderDatePriceInfo";
import LeftSide from './LeftSide';
import ChangePriceModal from './Modals/ChangePrice';
import moment from 'moment';
import axios from 'axios';
import { getHeader } from "../../helper";
import { fetchInfo } from "../../actions";
import { updateUserData } from "../../actions/session";
import { getCompanies, updateCompanyDataReceive } from "../../actions/companyActions";
import { updateOrderReceive, getExecutors } from "../../actions/orderActions";

class MakeOrderBidding extends Component {
    state = {
        isOpen: false,
        allList: false,

        changePrice: {
            type: 'default',
            show: false,
            price: 0,
            commission: 0,
            totalPrice: 0,
            oldTotalPrice: 0,
            oldPrice: 0,
        }
    }

    componentWillMount() {
        const { getExecutors, currentOrder } = this.props;
        getExecutors(currentOrder.id);
    }

    componentDidMount() {
        const { fetchInfo } = this.props;

        fetchInfo([
            {
                query: 'settings-tax',
                params: {}
            }
        ]);
    }

    stagesOfBidding(ordermilestone, current_milestone_id) {
        let stage_true = ordermilestone.findIndex(item => item.id === current_milestone_id);
        let length = ordermilestone.length;
        
        if(stage_true === -1) {
            return ordermilestone.slice(length - 3, length);
        }

        if (length > 3) {
            if (stage_true === length - 1) {
                return ordermilestone.slice(length - 3, length);
            } else {
                if (stage_true === 0) {
                    return ordermilestone.slice(0, 3);
                } else {
                    return ordermilestone.slice(stage_true - 1, stage_true + 2);
                }
            }
        }

        return ordermilestone;
    }

    allListOpen(event) {
        event.preventDefault();

        this.setState({
            allList: !this.state.allList
        });
    }

    handleComission() {
        const {data, currentOrder} = this.props;
        let { tax_percent, tax_min } = data["settings-tax"];
        const {contractor_count} = currentOrder;
        let {price, totalPrice, commission} = this.state.changePrice;
        totalPrice = price;

        if(!price || !(new RegExp('^\\d+$').test(price)) || price <= 0){
            commission = 0;
            totalPrice = 0;
        }
        
        if(price > 0 && contractor_count > 0) {
            commission = (price * contractor_count * tax_percent/100);

            if(commission < tax_min) commission = tax_min;

            totalPrice = price * contractor_count + commission;
         }

        this.setState({
            changePrice: {
                ...this.state.changePrice,
                price,
                totalPrice,
                commission,
            }
        });
    }

    changePrice(e) {
        e.preventDefault();
        const {currentOrder, getCompanies} = this.props;
        const {company_id, total_price, price} = currentOrder;

        if(company_id) {
            //company_id
            getCompanies({id: currentOrder.company_id})
        }

        this.setState({
            changePrice: {
                ...this.state.changePrice,
                show: true,
                oldTotalPrice: total_price,
                oldPrice: price,
            }
        })
    }

    calculationPrice(balance, totalPrice, oldTotalPrice) {
        if(parseFloat(oldTotalPrice) > parseFloat(totalPrice)){
            let num = parseFloat(oldTotalPrice) - parseFloat(totalPrice);
            balance = (balance + num);
        }
        else if(parseFloat(oldTotalPrice) < parseFloat(totalPrice)){
            let num = parseFloat(totalPrice) - parseFloat(oldTotalPrice);
            balance = (balance - num);
        }
        return balance;
    }

    changePriceConfirm() {
        const {currentOrder, updateUserData, session:{currentUser}, company:{companies}, updateCompanyDataReceive, updateOrderReceive} = this.props;
        const {price, oldTotalPrice, totalPrice} = this.state.changePrice;

        if(!currentOrder || !price || price === 0 || price.trim().length === 0) return false;
        let balance;
        let company;
        
        if(currentOrder.company_id) {
            let currentCompany = companies.data.results.filter(item => item.id === currentOrder.company_id);
            if(!currentCompany.length) return false;
            let newBalance = this.calculationPrice(currentCompany[0].balance, totalPrice, oldTotalPrice);
            
            company = Object.assign({}, currentCompany[0], {
                balance: newBalance
            });
        }
        else{
            balance = this.calculationPrice(currentUser.balance_customer, totalPrice, oldTotalPrice);
        }

        this.setState({
            changePrice: {
                ...this.state.changePrice,
                loading: true,
            }
        })

        axios.post(
            `${window.siteUrl}/api/v1/order/${currentOrder.id}/change_price/`,
            {
                new_price: price
            },
            {
                headers: getHeader()
            }
        )
        .then(response => {
            this.setState({
                changePrice: {
                    ...this.state.changePrice,
                    type: 'success',
                    loading: false,
                }
            });

            if(currentOrder.company_id) {
                updateCompanyDataReceive(company)
            }
            else{
                updateUserData({
                    balance_customer: balance
                })
            }

            updateOrderReceive({
                ...currentOrder,
                price: price,
                total_price: totalPrice,
            })

        })
        .catch(error => {
            let message = '';
            if(error.response.status === 500){
                message = {non_field: ['Ошибка сервера']}
            }
            else{
                message = {
                    ...error.response.data
                }
            }
            this.setState({
                changePrice: {
                    ...this.state.changePrice,
                    type: 'error',
                    error: message,
                    loading: false,
                }
            });
        });
    }

    changePriceClose() {
        this.setState({
            changePrice: {
                ...this.state.changePrice,
                show: false,
                type: 'default',
                price: 0,
                commission: 0,
                totalPrice: 0,
                oldTotalPrice: 0,
                oldPrice: 0,
            }
        })
    }

    handlePrice(value) {
        this.setState({
            changePrice: {
                ...this.state.changePrice,
                price: value,
            }
        }, () => this.handleComission())
    }

    getExecutorsColumn(currentOrder, item) {
        if(!currentOrder) return null;

        let currentTime = currentOrder.current_milestone_id === item.id;
        let count = item.bid_count;
        if(currentTime) count = currentOrder.bid_count;

        if(currentTime || item.is_finish) {
            let t = '';
            if(count > 1 && count <= 4) t = 'а';
            if(count > 4 || count === 0) t = 'ов';

            return [
                <strong key='1' className="stage">{item.num} этап - </strong>,
                <span key='2' className="members">
                    {`${count} участник${t}`}
                </span>
            ]
        }
        else return <strong key='1' className="stage">{item.num} этап</strong>
    }

    render() {
        const {orderList, currentOrder, repeatOrder, editOrder, currentCamera, cancelOrder} = this.props;

        const ordermilestone = this.state.allList ? currentOrder.ordermilestone_set : this.stagesOfBidding(currentOrder.ordermilestone_set, currentOrder.current_milestone_id);

        const {currentUser, isLoggedIn} = this.props.session;

        const executorById = orderList.orderById.executorById;
        let executorsWithoutAutoCancel = executorById.data.results.filter(item => item.status !== 7);

        return (
            <div>

                <ChangePriceModal
                    inputProps={this.state.changePrice}
                    onConfirm={() => this.changePriceConfirm()}
                    onCancel={() =>  this.changePriceClose()}
                    handlePrice={(value) => this.handlePrice(value)}
                    currentOrder={currentOrder}
                    />

                <div className="vertical-scrolling page fourthSection sectionMakeOrder" id="sectionMakeOrder" data-main-nav-id="makeOrdersNavLink">
                    <div className="container content">

                        <LeftSide
                            inputProps={{
                                orderId: currentOrder.id,
                                status: currentOrder.status,
                                is_failed: currentOrder.is_failed,
                                is_auction: currentOrder.is_auction,
                                fail_reason_str: currentOrder.fail_reason_str,
                                paramId: this.props.params.id,
                            }}
                        />

                        <div className="right-content native-scroll right-content-bottom right-content-width">
                            <div className="screen-outer-block-wrap native-scroll menu-content">

                                <div className="menu-content-make-order-bidding menu-content-item tab-parent screen-center-block">
                                    <div className="rounded-white-block">

                                        <div className="white-block-top header-tab">
                                            <h3>{currentOrder.title}</h3>
                                        </div>
                                        <div className="unlimited-block">

                                            <MakeOrderDatePriceInfo
                                                repeatOrder={repeatOrder}
                                                cancelOrder={cancelOrder}
                                                editOrder={editOrder}
                                                changePrice={(e) => this.changePrice(e)}
                                                currentUserID={currentUser.id}
                                                {...currentOrder}
                                                isLoggedIn={isLoggedIn}
                                                currentOrder={currentOrder}
                                                currentCamera={currentCamera}
                                                executors={executorsWithoutAutoCancel}
                                                />
                                            {
                                                currentOrder.is_auction
                                                ?
                                                <div>
                                                    <div className="semiheader" style={{justifyContent:'center'}}>
                                                        <h3 style={{width:'auto', flexGrow:1}}>Торги</h3>
                                                        <a href="" onClick={this.allListOpen.bind(this)} className="right-link" style={{width:'auto'}}>
                                                            {currentOrder.ordermilestone_set.length} этапов
                                                        </a>
                                                    </div>

                                                    <ul className="bidding-stages">
                                                        {
                                                            ordermilestone.map((item, index) =>
                                                                <li key={index}>
                                                                    <strong className="time">{moment(item.start_at).format('HH:mm')}</strong>
                                                                    {
                                                                        currentOrder.current_milestone_id === item.id ?
                                                                        <div className={"circle green"}></div>
                                                                        :
                                                                        <div className={item.is_finish ? "circle red" : "circle gray"}></div>
                                                                    }
                                                                    
                                                                    {this.getExecutorsColumn(currentOrder, item)}
                                                                </li>
                                                            )
                                                        }
                                                        
                                                        {/* <li>
                                                        <strong className="time">12:00</strong>
                                                        <div className="circle red"></div>
                                                        <strong className="stage">1 этап - </strong>
                                                        <span className="members">12 участников</span>
                                                    </li>
                                                    <li>
                                                        <strong className="time">13:00</strong>
                                                        <div className="circle green"></div>
                                                        <strong className="stage">2 этап - </strong>
                                                        <span className="members">7 участников</span>
                                                    </li>
                                                    <li>
                                                        <strong className="time">14:00</strong>
                                                        <div className="circle gray"></div>
                                                        <strong className="stage">3 этап - </strong>
                                                        <span className="members">2 участника</span>
                                                    </li> */}
                                                    </ul>
                                                </div>
                                                : ''
                                            }

                                            <div className="semiheader">
                                                <h3>Претенденты</h3>
                                            </div>

                                            {
                                                currentOrder.is_my_bid
                                                ?
                                                <h3 style={{padding:'20px', color: '#64ab15', fontSize:'15px'}}>Вы откликнулись на заказ</h3>
                                                : null
                                            }

                                            <div className="applicants">
                                                <p>На данном этапе <span className="text_pink_d">{currentOrder.bid_count}</span> претендентов</p>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(
    mapStateToProps,
    {
        fetchInfo,
        updateUserData,
        getCompanies,
        updateCompanyDataReceive,
        updateOrderReceive,
        getExecutors,
    }
)(MakeOrderBidding);


// WEBPACK FOOTER //
// ./src/components/MakeOrder/MakeOrderBiddingTest.js